"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toolbar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const utils_1 = require("../../utils");
const toolbar_button_1 = require("../toolbar-button");
const style_types_1 = require("./style-types");
const Toolbar = props => {
    const { inlineMode, controls, customControls = [], className, onClick, isActive, disabled, size } = props;
    const [availableControls, setAvailableControls] = (0, react_1.useState)(controls ? [] : style_types_1.STYLE_TYPES);
    const { editorState } = props;
    const id = inlineMode ? "-inline-toolbar" : "-toolbar";
    const curedControls = Array.isArray(controls) ? [...controls, ...customControls] : customControls;
    (0, react_1.useEffect)(() => {
        if (!controls) {
            return;
        }
        const filteredControls = [];
        controls
            .filter((control, index) => controls.indexOf(control) >= index)
            .forEach(name => {
            const style = style_types_1.STYLE_TYPES.find(style => style.name === name);
            if (style) {
                filteredControls.push(style);
            }
            else if (customControls.length) {
                const customControl = customControls.find(style => style.name === name);
                if (customControl && customControl.type !== "atomic" && (customControl.icon || customControl.component)) {
                    filteredControls.push({
                        id: customControl.id || customControl.name + "Id",
                        name: customControl.name,
                        label: customControl.name,
                        style: customControl.name.toUpperCase(),
                        icon: customControl.icon,
                        component: customControl.component,
                        type: customControl.type,
                        clickFnName: "onCustomClick",
                    });
                }
            }
        });
        setAvailableControls(filteredControls);
    }, curedControls);
    return ((0, jsx_runtime_1.jsx)("div", { id: id, className: className, "data-testid": "toolbar", children: availableControls.map(style => {
            if (inlineMode && style.type !== "inline" && style.name !== "link" && style.name !== "clear") {
                return null;
            }
            let active = false;
            const action = onClick;
            if (!isActive) {
                active = false;
            }
            else if (style.type === "inline") {
                active = editorState.getCurrentInlineStyle().has(style.style);
            }
            else if (style.type === "block") {
                const selection = editorState.getSelection();
                const block = editorState.getCurrentContent().getBlockForKey(selection.getStartKey());
                if (block) {
                    active = style.style === block.getType();
                }
            }
            else {
                if (style.style === "IMAGE" || style.style === "LINK") {
                    active = style.style === (0, utils_1.getSelectionInfo)(editorState).entityType;
                }
            }
            return ((0, jsx_runtime_1.jsx)(toolbar_button_1.ToolbarButton, { id: style.id, editorId: props.id, active: active, label: style.label, onClick: action, style: style.style, type: style.type, icon: style.icon, component: style.component, inlineMode: inlineMode, disabled: disabled, size: size }, `key-${style.label}`));
        }) }));
};
exports.Toolbar = Toolbar;
//# sourceMappingURL=index.js.map